import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          tracker_settings: {
            header: 'TRACKER_SETTINGS_HEADER',
            save: 'TRACKER_SETTINGS_SAVE',
            back: 'TRACKER_SETTINGS_BACK',
          },
        },
      },
    },
  }));
}
